import { FC } from 'react';
import { Modal, Tooltip } from '@bfe/moly';
import { useFm, useScreenType } from '@web3/base-hooks';
import {
  BybitWalletChromeExtensionLink,
  openLink,
  appPath,
} from '@web3/base-utils';

import Icon1 from '@/assets/icon/icon1.svg';
import Icon2 from '@/assets/icon/icon2.svg';
import Icon3 from '@/assets/icon/icon3.svg';
import AppleIcon from '@/assets/icon/apple.svg';
import ChromeIcon from '@/assets/icon/chrome.svg';
import QrIcon from '@/assets/icon/qr.svg';

import styles from './index.module.scss';
interface DownloadModalProps {
  visible: boolean;
  onClose: () => void;
}

const DownloadModal: FC<DownloadModalProps> = ({ visible, onClose }) => {
  const fm = useFm();
  const { isMobile } = useScreenType();

  const navTo = (url: string) => {
    if (isMobile) {
      openLink(url);
      return;
    }
    window.open(url, '_blank');
  };

  return (
    <Modal
      title={fm('downloadWallet')}
      isMobile={isMobile}
      open={visible}
      onCancel={onClose}
      footer={false}
    >
      <div className={styles.downloadContainer}>
        <div className={styles.title}>{fm('oneWalletForNeeds')}</div>
        <div className={styles.list}>
          <div className={styles.header}>
            <Icon1 style={{ width: 24, height: 32 }} />
            <div className={styles.t1}>{fm('download_bybit')}</div>
          </div>
          <div className={styles.body}>
            <div className={styles.cardBox}>
              <AppleIcon className={styles.img} />
              <div
                // href="https://apps.apple.com/gb/app/bybit-buy-trade-crypto/id1488296980?mt=8"
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  navTo(
                    'https://apps.apple.com/gb/app/bybit-buy-trade-crypto/id1488296980?mt=8'
                  )
                }
              >
                <div className={styles.desc}>Apple Store</div>
              </div>
            </div>
            <div className={styles.cardBox}>
              <Icon3 className={styles.img} />
              <div
                // href="https://play.google.com/store/apps/details?id=com.bybit.app&referrer=af_tranid%3DxT3WqUAuuNtLGWZkmr3dnQ%26af_dp%3Dbybitapp%253A%252F%252Fopen%252Fhome%253Ftab%253D0%26c%3Dappdownload_page_link%26pid%3Duj&pli=1"
                onClick={() =>
                  navTo(
                    'https://play.google.com/store/apps/details?id=com.bybit.app&referrer=af_tranid%3DxT3WqUAuuNtLGWZkmr3dnQ%26af_dp%3Dbybitapp%253A%252F%252Fopen%252Fhome%253Ftab%253D0%26c%3Dappdownload_page_link%26pid%3Duj&pli=1'
                  )
                }
              >
                <div className={styles.desc}>Google Play</div>
              </div>
            </div>
            {isMobile ? null : (
              <div
                className={styles.cardBox}
                style={{ justifyContent: 'center', paddingLeft: 16 }}
              >
                <Tooltip
                  title={
                    <img src={`${appPath}/png/home/appQR.png`} alt="img" />
                  }
                  placement="bottom"
                >
                  <QrIcon className={styles.img} />
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div className={styles.list}>
          <div className={styles.header}>
            <Icon2 style={{ width: 24, height: 32 }} />
            <div className={styles.t1}>Download Extension</div>
          </div>
          <div className={styles.body}>
            <div className={styles.cardBox}>
              <ChromeIcon className={styles.img} />
              <div onClick={() => navTo(BybitWalletChromeExtensionLink)}>
                <div className={styles.desc}>{fm('chromeExtension')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DownloadModal;
